module.exports = __webpack_public_path__ + "static/family-2eadaf9307bc5beca200b5c310084ec0.jpeg";